import React from "react";
import { Project } from "./interfaces/InformationInterface";

// interface IContext{
//     toggleColorMode: () => any,
//     refPageIndex?: React.MutableRefObject<number>,
//     onPageChange:(index:number)=>any,
// }

// export const Context = React.createContext<IContext>({
//     toggleColorMode: () => {},
//     refPageIndex: undefined,
//     onPageChange:(index:number)=>{},
// });
interface IContext{
    toggleColorMode: () => any,
    pageIndex:number,
    setPageChange:(index:number)=>any,
}

export const Context = React.createContext<IContext>({
    toggleColorMode: () => {},
    pageIndex: 0,
    setPageChange:(index:number)=>{},
  });